// src/components/OnboardingProgressBar.tsx

interface OnboardingProgressBarProps {
  currentStep: 1 | 2 | 3 | 4;
  steps: string[];
}

const OnboardingProgressBar = ({ currentStep, steps }: OnboardingProgressBarProps) => {
  return (
    
    <div className="w-full max-w-2xl mx-auto mb-8">
            {/* Current Step Label */}
      <p className="text-center text-lg pb-3 font-medium text-gray-700">
        {steps[currentStep - 1]}
      </p>
      {/* Progress Dots */}
      <div className="flex items-center justify-center gap-2 pt-1 mb-3">
        {steps.map((_, index) => {
          const stepNumber = index + 1;
          const isComplete = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          
          return (
            <div key={index} className="flex items-center pt-1">
              <div
                className={`w-4 h-4 rounded-full transition-all ${
                  isComplete
                    ? "bg-[#e54c4c]" // Crimson for completed
                    : isCurrent
                    ? "bg-[#e54c4c] ring-8 ring-[#e54c4c]/30" // Current with ring
                    : "bg-gray-300" // Gray for upcoming
                }`}
              />
              {index < steps.length - 1 && (
                <div
                  className={`w-8 h-1 ${
                    isComplete ? "bg-[#e54c4c]" : "bg-gray-300"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>


    </div>
  );
};

export default OnboardingProgressBar;